import { Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Spinner, Pressable } from 'native-base';
import React from 'react';

import { useSpreadsheetDownload } from '../../hooks/spreadsheet-download';

interface SpreadsheetDownloadProps {}

export const SpreadsheetDownload: React.FC<SpreadsheetDownloadProps> = () => {
  const { handleRequestRedeemSpreadsheet, isPendingSpreadsheetDownload } = useSpreadsheetDownload();
  return (
    <Pressable onPress={handleRequestRedeemSpreadsheet} isDisabled={isPendingSpreadsheetDownload}>
      <Shadow level={1} borderRadius={BoxRadius.sm}>
        <HStack
          borderRadius={BoxRadius.sm}
          alignItems="center"
          justifyContent="space-between"
          w="full"
          space={Spacing['inline.nano']}
          p={Spacing['inline.xxxs']}>
          <Icon name="Info" size="xxs" color={Color['brand.tertiary.principal']} />
          <VStack space={Spacing['inline.quarck']} flex={1}>
            <VStack>
              <Text color="neutral.black" variant="semibold">
                Solicitar planilha base para resgate
              </Text>
              <Text color="neutral.medium">
                Baixe a planilha base, insira os dados, em seguida, importe na plataforma.
              </Text>
            </VStack>
          </VStack>
          {isPendingSpreadsheetDownload && (
            <Spinner size="sm" color={Color['brand.tertiary.principal']} />
          )}
          {!isPendingSpreadsheetDownload && (
            <Icon name="Download" size="xs" color={Color['brand.tertiary.principal']} />
          )}
        </HStack>
      </Shadow>
    </Pressable>
  );
};
